import { render, staticRenderFns } from "./InstantUpdateBoolean.vue?vue&type=template&id=2fb4f1dc"
import script from "./InstantUpdateBoolean.vue?vue&type=script&lang=ts"
export * from "./InstantUpdateBoolean.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports